import React from 'react';
import Listing from 'components/common/Listing';
import Carousel from 'components/common/Carousel';

function renderListings(listings, query) {
  return Object.keys(listings).map(listingId => (
    <div className="px-sm-3" key={listingId}><Listing {...listings[listingId]} query={query}/></div>
  ));
}

const slickOptions = {
  infinite: true,
  slidesToShow: 3,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 992,
      settings: {
        slidesToShow: 2
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1
      }
    }
  ]
};

export default ({ listings, query }) => {
  return (
    <Carousel slickOptions={slickOptions}>
      {renderListings(listings, query)}
    </Carousel>
  );
};


// WEBPACK FOOTER //
// ./src/components/ListingCarousel.js